"use client"

import * as Dialog from "@radix-ui/react-dialog"
import { clsx } from "@/src/utils/clsx"

type CutoverMessageModalProps = {
    isOpen: boolean
    onClose: () => void
}

export default function CutoverMessageModal({
    isOpen,
    onClose
}: CutoverMessageModalProps) {
    return (
        <Dialog.Root open={isOpen} onOpenChange={onClose}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 z-[99] bg-black/40 backdrop-blur-sm" />
                <Dialog.Content
                    className={clsx(
                        "fixed left-1/2 top-1/2 z-[100] w-[300px] -translate-x-1/2 -translate-y-1/2",
                        "flex flex-col items-center gap-16 rounded-lg bg-white px-20 py-24",
                        "transition-opacity duration-150 ease-custom-ease"
                    )}
                >
                    <div className="text-center">
                        <p className="Trim_Mono_Regular_POC_Header_24_130_1_300_uppercase break-words text-col-text-primary">
                            We&apos;re Upgrading
                        </p>
                        <p className="mt-12 break-words text-col-text-secondary Trade_Gothic_Text_16_150_0_300">
                            Our basket system is currently being upgraded. Checkout will
                            be back online in roughly 15 minutes — apologies for the
                            interruption.
                        </p>
                    </div>

                    <Dialog.Close asChild>
                        <button
                            className="flex h-40 w-full items-center justify-center rounded-full bg-black px-20 py-16 text-white Trim_Mono_POC_Text_14_130_0_400_uppercase hover:bg-col-bg-strong"
                            onClick={onClose}
                        >
                            Got it
                        </button>
                    </Dialog.Close>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    )
}
